import type { FC } from 'react';
import type { ImpliedRealizedVolatilityProps } from './types';
import ImpliedRealizedVolatilityWidget from './implied-realized-volatility-widget';
import { ImpliedRealizedVolatilityProvider } from '../../../../providers/widgets';

const ImpliedRealizedVolatilityWrapperProvider: FC<ImpliedRealizedVolatilityProps> = (props) => (
  <ImpliedRealizedVolatilityProvider providerKey={props.providerKey}>
    <ImpliedRealizedVolatilityWidget {...props} />
  </ImpliedRealizedVolatilityProvider>
);

export default ImpliedRealizedVolatilityWrapperProvider;
